import { render, staticRenderFns } from "./shareReferralLink.vue?vue&type=template&id=f640b47e"
import script from "./shareReferralLink.vue?vue&type=script&lang=js"
export * from "./shareReferralLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports